
import React from 'react'
import { Grid } from '@material-ui/core';
import Searchicons from'@material-ui/icons/Search';
import './style.css';

function NoSearchResult() {
    return (
        <div className="MuiGrid-container">
            <Grid id="divnoSearchresult">
                <Grid className='nomatchdatacontainer'>
                    <Grid component="div" justify='center'>
                        <div className='icon-holder-box'>
                            <Searchicons fontSize='Large' />
                        </div>
                    </Grid>
                    <div className='no-matching-results'>
                        No matching results
                    </div> 
                    <div className='there-arent-any-mat'>
                        There aren’t any matching results for your search. Please try something else.
                    </div> 
                </Grid>
            </Grid>
        </div>
    );
};

export default NoSearchResult;
